document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.slideshow__media');

  slides.forEach(slide => {
    const img = slide.querySelector('img');
    if (img && img.src) {
      slide.style.setProperty('--bg-image', `url(${img.src})`);
      slide.style.backgroundImage = `url(${img.src})`;
    }
  });
});
